import * as models from "../models/";

export function generateRandomColors(count: number): models.IColor[]
{
    var colors: models.IColor[] = [];

    for (var i = 0; i < count; i++)
    {
        var col: string = '#' + Math.floor(Math.random() * 16777215).toString(16);
        colors.push({
            name: i.toString(),
            color: col
        });
    }

    return colors;

    function rand(min, max)
    {
        return min + Math.random() * (max - min);
    }

    function get_random_color()
    {
        var h = rand(1, 360);
        var s = rand(0, 100);
        var l = rand(0, 100);
        return 'hsl(' + h + ',' + s + '%,' + l + '%)';
    }
}

/**
 * Konvertiert RGB in HEX.
 * @param r Rot
 * @param g Grün
 * @param b Blau
 */
export function rgbToHex(r: number, g: number, b: number): string
{
    return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
}

/**
 * Konvertiert HEX in RGB
 * @param hex
 */
export function hexToRgb(hex: string): models.IRgb
{
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}

/**
 * Konvertiert HEX in HSB
 * @param hex
 */
export function hexToHSB(hex): number[]
{
    hex = hex.replace(/^#/, "");
    hex = hex.length === 3 ? hex.replace(/(.)/g, "$1$1") : hex;

    var red = parseInt(hex.substr(0, 2), 16) / 255,
        green = parseInt(hex.substr(2, 2), 16) / 255,
        blue = parseInt(hex.substr(4, 2), 16) / 255;

    var cMax = Math.max(red, green, blue),
        delta = cMax - Math.min(red, green, blue),
        saturation = cMax ? (delta / cMax) : 0;

    switch (cMax)
    {
        case red: return [60 * (((green - blue) / delta) % 6) || 0, saturation, cMax];
        case green: return [60 * (((blue - red) / delta) + 2) || 0, saturation, cMax];
        case blue: return [60 * (((red - green) / delta) + 4) || 0, saturation, cMax];
    }
}

export function hsvToHSL(hsv)
{
    var h = hsv[0],
        s = hsv[1] / 100,
        v = hsv[2] / 100,
        k = (2 - s) * v;

    return [
        h,
        Math.round(s * v / (k < 1 ? k : 2 - k) * 10000) / 100,
        k / 2 * 100
    ];
}

export function hsvToRGB(hsv)
{
    // this doesn't work for the values of 0 and 360
    // here's the hacky fix
    var h = hsv[0];
    if (h === 0) { h = 1; }
    if (h === 360) { h = 359; }

    // Rebase the h,s,v values
    h = h / 360;
    var s = hsv[1] / 100,
        v = hsv[2] / 100;

    var h_i = Math.floor(h * 6),
        f = h * 6 - h_i,
        p = v * (1 - s),
        q = v * (1 - f * s),
        t = v * (1 - (1 - f) * s),
        r = 256,
        g = 256,
        b = 256;

    switch (h_i)
    {
        case 0: r = v; g = t; b = p; break;
        case 1: r = q; g = v; b = p; break;
        case 2: r = p; g = v; b = t; break;
        case 3: r = p; g = q; b = v; break;
        case 4: r = t; g = p; b = v; break;
        case 5: r = v; g = p; b = q; break;
    }

    var result = [Math.floor(r * 255), Math.floor(g * 255), Math.floor(b * 255)];
    return result;
}

export function hsvToHex(hsv)
{
    var rgb = hsvToRGB(hsv);

    function componentToHex(c)
    {
        var hex = c.toString(16);
        return hex.length == 1 ? '0' + hex : hex;
    }

    var hex = '#' + componentToHex(rgb[0]) + componentToHex(rgb[1]) + componentToHex(rgb[2]);
    return hex;
}

/**
 * Ändert die Deckkraft einer Farbe.
 * @param color Die Farbe die verändert werden soll.
 * @param percent Die Deckkraft in Prozent.
 */
export function opacity(color: string, percent: number): string
{
    if (!color)
        return;

    if (color.length > 7)
    {

    }
    else
    {
        let rgb: models.IRgb = this.hexToRgb(color);
        return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${percent.toString()})`;
    }
}

/**
 * Dunkelt eine Farbe ab.
 * @param color Die Farbe die verändert werden soll.
 * @param percent Den Verdunklungsgrad in Prozent.
 */
export function darken(color: string, percent: number): string
{
    if (color.length > 7)
        return shadeColorRgb(color, percent * -1);
    else
        return shadeColor(color, percent * -1);
}

/**
 * Hellt eine Farbe auf.
 * @param color Die Farbe die verändert werden soll.
 * @param percent Den Grad des aufhellens in Prozent.
 */
export function lighten(color: string, percent: number): string
{
    if (color.length > 7)
        return shadeColorRgb(color, percent);
    else
        return shadeColor(color, percent);
}

/**
 * Vermischt zwei Farben miteinander.
 * @param from
 * @param to
 * @param percent
 */
export function blend(from: string, to: string, percent: number): string
{
    if (from.length > 7)
        return blendColorsRgb(from, to, percent);
    else
        return blendColors(from, to, percent);
}

function componentToHex(c): string
{
    var hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
}

function shadeColor(color, percent)
{
    //let col = color;
    var f = parseInt(color.slice(1), 16), t = percent < 0 ? 0 : 255, p = percent < 0 ? percent * -1 : percent, R = f >> 16, G = f >> 8 & 0x00FF, B = f & 0x0000FF;
    return "#" + (0x1000000 + (Math.round((t - R) * p) + R) * 0x10000 + (Math.round((t - G) * p) + G) * 0x100 + (Math.round((t - B) * p) + B)).toString(16).slice(1);
}

function shadeColorRgb(color, percent)
{
    var f = color.split(","), t = percent < 0 ? 0 : 255, p = percent < 0 ? percent * -1 : percent, R = parseInt(f[0].slice(4)), G = parseInt(f[1]), B = parseInt(f[2]);
    return "rgb(" + (Math.round((t - R) * p) + R) + "," + (Math.round((t - G) * p) + G) + "," + (Math.round((t - B) * p) + B) + ")";
}

function blendColors(c0, c1, p)
{
    var f = parseInt(c0.slice(1), 16), t = parseInt(c1.slice(1), 16), R1 = f >> 16, G1 = f >> 8 & 0x00FF, B1 = f & 0x0000FF, R2 = t >> 16, G2 = t >> 8 & 0x00FF, B2 = t & 0x0000FF;
    return "#" + (0x1000000 + (Math.round((R2 - R1) * p) + R1) * 0x10000 + (Math.round((G2 - G1) * p) + G1) * 0x100 + (Math.round((B2 - B1) * p) + B1)).toString(16).slice(1);
}

function blendColorsRgb(c0, c1, p)
{
    var f = c0.split(","), t = c1.split(","), R = parseInt(f[0].slice(4)), G = parseInt(f[1]), B = parseInt(f[2]);
    return "rgb(" + (Math.round((parseInt(t[0].slice(4)) - R) * p) + R) + "," + (Math.round((parseInt(t[1]) - G) * p) + G) + "," + (Math.round((parseInt(t[2]) - B) * p) + B) + ")";
}